import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { Accordion, Icon } from "semantic-ui-react";
import { postalRegex } from "../../utils/regex";
const CustmerAddress = ({ getCustomerAddress, clearFields }) => {
  const [activeDetails, setActiveDetails] = useState(false);
  const [addressLine1, setAddressLine1] = useState(null);
  const [addressLine2, setAddressLine2] = useState(null);
  const [city, setCity] = useState(null);
  const [province, setProvince] = useState(null);
  const [error, setError] = useState(null);
  const [companyName, setCompanyName] = useState(null);
  const [zip, setZip] = useState(null);

  useEffect(() => {
    if (
      !error &&
      addressLine1 &&
      addressLine2 &&
      city &&
      province &&
      companyName &&
      zip &&
      postalRegex.test(zip)
    ) {
      getCustomerAddress({
        address_line_1: addressLine1,
        address_line_2: addressLine2,
        city: city,
        company_name: companyName,
        postal_code: zip,
        state_province: province,
      });
    }
  }, [addressLine1, addressLine2, city, province, error, companyName, zip]);

  const zipcodeInput = (event) => {
    if (postalRegex.test(event.target.value)) {
      setZip(event.target.value);
      setError(null);
    } else {
      setError("Invalid Zipcode (Valid Format xxxxx-xxxx or xxxxx)");
    }
  };

  useEffect(() => {
    if (clearFields) {
      setActiveDetails(false);
      setAddressLine1("");
      setAddressLine2("");
      setCity("");
      setProvince("");
      setCompanyName("");
      setZip("");
    }
  }, [clearFields]);
  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;

    switch (name) {
      case "addressLine1":
        if (typeof value === "string" || value instanceof String) {
          setAddressLine1(value);
          if (error) {
            setError(null);
          }
        } else {
          setError("Invalid address line 1");
        }
        break;
      case "addressLine2":
        if (typeof value === "string" || value instanceof String) {
          setAddressLine2(value);
          if (error) {
            setError(null);
          }
        } else {
          setError("Invalid address line 2");
        }

        break;
      case "city":
        if (typeof value === "string" || value instanceof String) {
          setCity(value);
          if (error) {
            setError(null);
          }
        } else {
          setError("Invalid city");
        }
        break;
      case "companyName":
        if (typeof value === "string" || value instanceof String) {
          setCompanyName(value);
          if (error) {
            setError(null);
          }
        } else {
          setError("Invalid company name");
        }
        break;
      case "province":
        if (typeof value === "string" || value instanceof String) {
          setProvince(value);
          if (error) {
            setError(null);
          }
        } else {
          setError("Invalid province");
        }
        break;

      default: {
      }
    }
  };

  const debouncedChangeHandler = useCallback(debounce(zipcodeInput, 350), []);
  const debouncedChangeHandlerForInput = useCallback(
    debounce(handleChange, 300),
    []
  );

  return (
    <Accordion styled className="custom-accordian">
      <Accordion.Title
        active={activeDetails}
        index={0}
        onClick={() => setActiveDetails(!activeDetails)}
        className="custmer-header-name"
      >
        <div>
          Customer Address<span className="required">*</span>
        </div>
        <Icon name="dropdown" />
      </Accordion.Title>
      <Accordion.Content active={activeDetails}>
        <div className="step-header">
          {error && <p className="errorText">{error}</p>}
        </div>

        <div className="set-two-data">
          <div className="one">
            <div className="form-group ">
              <label htmlFor="rnumber">
                Address Line 1 <span className="required">*</span>
              </label>
              <input
                id="rnumber"
                type="text"
                placeholder="Address Line 1"
                autoComplete="off"
                name="addressLine1"
                onChange={debouncedChangeHandlerForInput}
              />
            </div>
          </div>
          <div className="one">
            <div className="form-group ">
              <label htmlFor="rnumber">
                Address Line 2 <span className="required">*</span>
              </label>
              <input
                id="rnumber"
                type="text"
                placeholder="Address Line 2"
                autoComplete="off"
                name="addressLine2"
                onChange={debouncedChangeHandlerForInput}
              />
            </div>
          </div>
          <div className="one">
            <div className="form-group ">
              <label htmlFor="rnumber">
                City <span className="required">*</span>
              </label>
              <input
                id="rnumber"
                type="text"
                placeholder="City"
                autoComplete="off"
                name="city"
                onChange={debouncedChangeHandlerForInput}
              />
            </div>
          </div>
          <div className="one">
            <div className="form-group ">
              <label htmlFor="rnumber">
                Company Name <span className="required">*</span>
              </label>
              <input
                id="rnumber"
                type="text"
                placeholder="Texas Lone Star"
                autoComplete="off"
                name="companyName"
                onChange={debouncedChangeHandlerForInput}
              />
            </div>
          </div>
          <div className="one">
            <div className="form-group ">
              <label htmlFor="rnumber">
                Postal Code <span className="required">*</span>
              </label>
              <input
                id="rnumber"
                type="text"
                placeholder="12345-1234"
                autoComplete="off"
                name="routingNumber"
                onChange={debouncedChangeHandler}
              />
            </div>
          </div>

          <div className="one">
            <div className="form-group ">
              <label htmlFor="rnumber">
                State Province <span className="required">*</span>
              </label>
              <input
                id="rnumber"
                type="text"
                placeholder="Enter State Province"
                autoComplete="off"
                name="province"
                onChange={debouncedChangeHandlerForInput}
              />
            </div>
          </div>
        </div>
      </Accordion.Content>
    </Accordion>
  );
};
//
export default CustmerAddress;
